import React, { useState, useEffect } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { getAuth, signOut } from "firebase/auth";
import { doc, getDoc } from "firebase/firestore";
import { db } from "../../lib/firebase";
import "../../styles/Sidebar.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faLandmark,
  faUserSecret,
  faUserCog,
  faFileShield,
  faGlobe,
  faSignOutAlt,
  faCommentsDollar,
  faCircleDollarToSlot,
  faCreditCardAlt,
  faFileInvoiceDollar,
  faChartLine,
  faInfoCircle,
  faPlugCircleBolt,
  faPlugCirclePlus,
  faPlugCircleMinus,
} from "@fortawesome/free-solid-svg-icons";
import { matchPath } from "react-router-dom";
import { faBitcoin } from "@fortawesome/free-brands-svg-icons";

function SideItem({ closeMenu }) {
  const navigate = useNavigate();
  const auth = getAuth();
  const [user, setUser] = useState(null);
  const [userRole, setUserRole] = useState(null);
  const location = useLocation();
  const [isOpen, setIsOpen] = useState(false);

  const toggleDropdown = () => {
    setIsOpen(!isOpen);
  };

  useEffect(() => {
    const unsubscribe = auth.onAuthStateChanged(async (authUser) => {
      if (authUser) {
        setUser(authUser);
        const userDocRef = doc(db, "users", authUser.uid);
        const userDoc = await getDoc(userDocRef);

        if (userDoc.exists()) {
          const userData = userDoc.data();
          setUserRole(userData.role || null);
        } else {
          console.log("No user document found");
        }
      } else {
        setUser(null);
      }
    });

    return () => unsubscribe();
  }, [auth]);

  const isActive = (path) => {
    const match = matchPath(path, location.pathname);
    return match !== null;
  };

  const handleLogout = () => {
    signOut(auth)
      .then(() => {
        console.log("User signed out");
        navigate("/");
      })
      .catch((error) => console.error("Error signing out: ", error));
  };

  return (
    <div className="sidebars">
      {userRole === "admin" && (
        <div className="side-item-admin">
          <div className="route-Link" onClick={toggleDropdown}>
            <FontAwesomeIcon icon={faUserSecret} className="icons" /> Admin
            Panel
          </div>

          {isOpen && (
            <ul className="admin-drop-down-list">
              <li className="admin-dropdown-item">
                <Link
                  to="/get-admin"
                  className={`admin-link ${isActive("/get-admin") ? "active" : ""}`}
                  onClick={() => {
                    closeMenu();
                  }}
                >
                  - All Users
                </Link>
              </li>
              <li className="admin-dropdown-item">
                <Link
                  to="/userdetail/add-transaction"
                  className={`admin-link ${isActive("/userdetail/add-transaction") ? "active" : ""}`}
                  onClick={() => {
                    closeMenu();
                  }}
                >
                  - Add Transaction
                </Link>
              </li>
              <li className="admin-dropdown-item">
                <Link
                  to="/plans"
                  className={`admin-link ${isActive("/plans") ? "active" : ""}`}
                  onClick={() => {
                    closeMenu();
                  }}
                >
                  - All Plans
                </Link>
              </li>
              <li className="admin-dropdown-item">
                <Link
                  to="/wallets"
                  className={`admin-link ${isActive("/wallets") ? "active" : ""}`}
                  onClick={() => {
                    closeMenu();
                  }}
                >
                  - Wallets
                </Link>
              </li>
              <li className="admin-dropdown-item">
                <Link
                  to="/accounts"
                  className={`admin-link ${isActive("/accounts") ? "active" : ""}`}
                   onClick={() => {
                    closeMenu();
                  }}
                >
                  - Accounts
                </Link>
              </li>
              <li className="admin-dropdown-item">
                <Link
                  to="/buy-coin"
                  className={`admin-link ${isActive("/buy-coin") ? "active" : ""}`}
                   onClick={() => {
                    closeMenu();
                  }}
                >
                  - Buy Coin
                </Link>
              </li>
              <li className="admin-dropdown-item">
                <Link
                  to="/admin-funding"
                  className={`admin-link ${isActive("/admin-funding") ? "active" : ""}`}
                   onClick={() => {
                    closeMenu();
                  }}
                >
                  - Admin Funding
                </Link>
              </li>
            </ul>
          )}
        </div>
      )}

      <div className="sidebar-label">Online Banking</div>

      <div className="side-item">
        <Link
          to="/"
          className={`route-Link ${isActive("/") ? "active" : ""}`}
          onClick={() => {
            closeMenu();
          }}
        >
          <FontAwesomeIcon icon={faLandmark} className="icons" /> Account
          Overview
        </Link>
      </div>

      <div className="side-item">
        <Link
          to="/transactions"
          className={`route-Link ${isActive("/transactions") ? "active" : ""}`}
          onClick={() => {
            closeMenu();
          }}
        >
          <FontAwesomeIcon icon={faFileInvoiceDollar} className="icons" />{" "}
          Transactions
        </Link>
      </div>

      <div className="side-item">
        <Link
          to="/transfer"
          className={`route-Link ${isActive("/transfer") ? "active" : ""}`}
          onClick={() => {
            closeMenu();
          }}
        >
          <FontAwesomeIcon icon={faCommentsDollar} className="icons" /> Make a
          Transfer
        </Link>
      </div>

      <div className="side-item">
        <Link
          to="/my-card"
          className={`route-Link ${isActive("/my-card") ? "active" : ""}`}
          onClick={() => {
            closeMenu();
          }}
        >
          <FontAwesomeIcon icon={faCreditCardAlt} className="icons" /> Sky Cards
        </Link>
      </div>

      <div className="side-item">
        <Link
          to="/loans"
          className={`route-Link ${isActive("/loans") ? "active" : ""}`}
          onClick={() => {
            closeMenu();
          }}
        >
          <FontAwesomeIcon icon={faCircleDollarToSlot} className="icons" /> Get
          Loans
        </Link>
      </div>

      <div className="sidebar-label">Sky FXT</div>

      <div className="side-item">
        <Link
          to="/fxt"
          className={`route-Link ${isActive("/fxt") ? "active" : ""}`}
          onClick={() => {
            closeMenu();
          }}
        >
          <FontAwesomeIcon icon={faChartLine} className="icons" /> FXT Dashboard
        </Link>
      </div>

      <div className="side-item">
        <Link
          to="/fxt/trade"
          className={`route-Link ${isActive("/fxt/trade") ? "active" : ""}`}
          onClick={() => {
            closeMenu();
          }}
        >
          <FontAwesomeIcon icon={faPlugCircleBolt} className="icons" /> Trade
          wit Sky
        </Link>
      </div>

      <div className="side-item">
        <Link
          to="/fxt/deposit"
          className={`route-Link ${isActive("/fxt/deposit") ? "active" : ""}`}
          onClick={() => {
            closeMenu();
          }}
        >
          <FontAwesomeIcon icon={faPlugCirclePlus} className="icons" /> Deposit
        </Link>
      </div>

      <div className="side-item">
        <Link
          to="/fxt/withdraw"
          className={`route-Link ${isActive("/fxt/withdraw") ? "active" : ""}`}
          onClick={() => {
            closeMenu();
          }}
        >
          <FontAwesomeIcon icon={faPlugCircleMinus} className="icons" />{" "}
          Withdraw
        </Link>
      </div>

      <div className="side-item">
        <Link
          to="/buy"
          className={`route-Link ${isActive("/buy") ? "active" : ""}`}
          onClick={() => {
            closeMenu();
          }}
        >
          <FontAwesomeIcon icon={faBitcoin} className="icons" /> Buy Crypto
        </Link>
      </div>

      <div className="side-item">
        <Link
          to="/fxt/transactions"
          className={`route-Link ${isActive("/fxt/transactions") ? "active" : ""}`}
          onClick={() => {
            closeMenu();
          }}
        >
          <FontAwesomeIcon icon={faInfoCircle} className="icons" /> Trade
          History
        </Link>
      </div>

      <div className="sidebar-label">Settings</div>

      <div className="side-item">
        <Link
          to={user ? `/user/${user.uid}` : "#"}
          className={`route-Link ${user && isActive(`/user/${user.uid}`) ? "active" : ""}`}
          onClick={() => {
            closeMenu();
          }}
        >
          <FontAwesomeIcon icon={faUserCog} className="icons" /> Profile
        </Link>
      </div>

      {(userRole === "admin" || userRole === "moderator") && (
        <div className="side-item">
          <Link
            to="/admin-funding"
            className={`route-Link ${isActive("/admin-funding") ? "active" : ""}`}
            onClick={() => {
              closeMenu();
            }}
          >
            <FontAwesomeIcon icon={faUserSecret} className="icons" /> Moderator
            Funding
          </Link>
        </div>
      )}

      <div className="sidebar-label">Support</div>

      <div className="side-item">
        <Link
          to="/about-us"
          className={`route-Link ${isActive("/about-us") ? "active" : ""}`}
          onClick={() => {
            closeMenu();
          }}
        >
          <FontAwesomeIcon icon={faGlobe} className="icons" /> About Us
        </Link>
      </div>

      <div className="side-item">
        <Link
          to="/terms"
          className={`route-Link ${isActive("/terms") ? "active" : ""}`}
          onClick={() => {
            closeMenu();
          }}
        >
          <FontAwesomeIcon icon={faFileShield} className="icons" /> Terms &
          Conditions
        </Link>
      </div>

      <div onClick={handleLogout} className="log-out">
        <FontAwesomeIcon icon={faSignOutAlt} className="icons" /> Logout
      </div>
    </div>
  );
}

export default SideItem;
